import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { ButtonToolbar } from 'reactstrap';
import { CABIN_CREW_BUS_ASSIGNMENT_PATH } from '../../../../config/paths';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import Loader from '../../../common/Loader';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { Table } from '../../../common/Table';
import EditCabinCrewBusAssignmentButton from './EditCabinCrewBusAssignmentButton';
import Alert from '../../../common/informative/Alert';
import NoDataResource from '../../../common/resource/NoDataResource';
import Content from '../../../layout/Content';
import { clearCabinCrewBusAssignment, getCabinCrewBusAssignment } from '../../../../actions/traffic/CabinCrewBusAssignment';

class CabinCrewBusAssignment extends Component {
  componentDidMount() {
    const {
      dispatchGetCabinCrewBusAssignmentByBus,
      match: {
        params: { id },
      },
    } = this.props;
    dispatchGetCabinCrewBusAssignmentByBus({ id });
  }

  componentWillUnmount() {
    const { dispatchClearCabinCrewBusAssignment } = this.props;
    dispatchClearCabinCrewBusAssignment();
  }

  render() {
    const {
      breadcrumbs,
      cabinCrewBusAssignment,
      loading,
      match: {
        params: { id },
      },
    } = this.props;

    let content;
    let toolbar;

    if (loading) {
      content = <Loader />;
    } else if (cabinCrewBusAssignment.isEmpty()) {
      content = <NoDataResource returnPage={CABIN_CREW_BUS_ASSIGNMENT_PATH} />;
    } else {
      const cabinCrewList = cabinCrewBusAssignment.get('cabinCrewAssignmentDateList');
      const items = (
        <div>
          <h3>Lista de Servicio a Bordo</h3>
          <Table
            columns={[
              {
                Header: 'Servicio a Bordo',
                accessor: 'cabinCrew.customer.fullName',
                className: 'text-center',
              },
              {
                Header: 'DNI',
                accessor: 'cabinCrew.customer.idDocumentNumber',
                className: 'text-center',
              },
            ]}
            data={cabinCrewList}
            defaultPageSize={cabinCrewList.length}
            showPagination={false}
          />
        </div>
      );

      content = (
        <Alert message="El bus seleccionado no tiene servicio a bordo asignado" />
      );

      if (cabinCrewBusAssignment.get('registeredBus')) {
        toolbar = (
          <ButtonToolbar className="pull-right">
            <div>
              <EditCabinCrewBusAssignmentButton
                cabinCrewBusAssignmentId={parseInt(id, 10)}
              />
            </div>
          </ButtonToolbar>
        );

        content = (
          <Fragment>
            <ResourceProperty label="Bus:">
              {cabinCrewBusAssignment.get('registeredBus').companyBusId}
            </ResourceProperty>
            {items}
          </Fragment>
        );
      }
    }

    return (
      <Content
        breadcrumbs={breadcrumbs}
        title="Asignación de Servicio a Bordo"
        toolbar={toolbar}
        content={content}
      />
    );
  }
}

CabinCrewBusAssignment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetCabinCrewBusAssignmentByBus: PropTypes.func.isRequired,
  dispatchClearCabinCrewBusAssignment: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  cabinCrewBusAssignment: PropTypes.instanceOf(Immutable.Map).isRequired,
};

CabinCrewBusAssignment.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
    {
      text: 'Asignaciones de Servicio a Bordo',
      href: CABIN_CREW_BUS_ASSIGNMENT_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  cabinCrewBusAssignment: TrafficUnit.CabinCrewBusAssignment.getIn([
    'current',
    'content',
  ]),
  loading: !TrafficUnit.CabinCrewBusAssignment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetCabinCrewBusAssignmentByBus: getCabinCrewBusAssignment,
  dispatchClearCabinCrewBusAssignment: clearCabinCrewBusAssignment,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CabinCrewBusAssignment);